import CustomToolTip from "../../../../components/CustomTooltip";
import { getPrettyDate, useLocalTime } from "../../../../utils/timestamp";
import CustomLabel from "../../frameworks/components/CustomLabel";

const DAYS_TO_BE_NEW = 7;

// Check if the item (Control/Entity) was found in the last DAYS_TO_BE_NEW days
// This is used to indicate for the user that the item is new
// and should be reviewed
export const isRecentlyFound = (timestamp_utc) => {
  const foundOn = new Date(timestamp_utc * 1000);
  const today = new Date();
  const diffTime = Math.abs(today.getTime() - foundOn.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays <= DAYS_TO_BE_NEW;
};

export default function RecentlyFoundLabel({ foundTimestamp = "" }) {
  const showLocalTime = useLocalTime();
  return (
    <CustomToolTip
      placement="top"
      title={
        foundTimestamp
          ? "Found on " + getPrettyDate(foundTimestamp, showLocalTime)
          : ""
      }
    >
      <span>
        <CustomLabel
          colorFamily={"primary"}
          severity={"main"}
          text={"New"}
          labelType="soft"
          size={"small"}
        />
      </span>
    </CustomToolTip>
  );
}
